import { useState } from "react";
import { Button } from "../../../../components/ui/Button";
import { Slider } from "../../../../components/ui/Slider";

type SliderQuestionProps = {
  subtitle?: string;
  question: string;
  minLabel: string;
  maxLabel: string;
  options: string[];
  onSelect: (option: string) => void;
};

export const SliderQuestion = ({
  subtitle,
  question,
  minLabel,
  maxLabel,
  options,
  onSelect,
}: SliderQuestionProps) => {
  const [value, setValue] = useState<number[]>([0]);

  const handleSelect = (value: number[]) => {
    const valueIndex = Math.floor((value[0] * options.length) / 100);
    onSelect(options[valueIndex]);
  };

  return (
    <div
      className="flex flex-col w-full p-4 rounded-[2px] gap-6 items-center"
      style={{
        background: "rgba(59, 59, 59, 0.20)",
        backdropFilter: "blur(20px)",
      }}
    >
      <div className="flex flex-col gap-2 w-full items-center font-minion">
        <p className="text-[#FAF5F1] font-minion text-[14px] font-normal leading-[150%]">
          {subtitle}
        </p>
        <h1 className="text-white text-center font-minion text-[20px] font-normal">
          {question}
        </h1>
      </div>
      <div className="h-24 flex items-center px-2 w-full">
        <Slider
          className="w-full"
          value={value}
          onValueChange={setValue}
          max={99}
        />
      </div>
      <div className="flex justify-between w-full items-center font-minion">
        <SliderBound label={minLabel} />
        <SliderBound label={maxLabel} />
      </div>
      <Button
        className="w-fit"
        variant="primary"
        onClick={() => handleSelect(value)}
      >
        <p className="px-4">Continue</p>
      </Button>
    </div>
  );
};

export const SliderBound = ({ label }: { label: string }) => {
  return (
    <p className="text-primary font-minion text-[16px] font-normal leading-[150%]">
      {label}
    </p>
  );
};
